import { Box } from '@mantine/core';
import { useResponsiveDesign } from 'hooks/use-responsive-design';
import { useDashboardLayout } from 'layouts/dashboard/use-dashboard-layout';
import { useMemo } from 'react';

/**
 * Parameters of the TableWrapper component.
 */
export interface TableWrapperProps {
  children: React.ReactNode;
  heightCompensation?: number;
}

/**
 * Element that wraps a table and adds some styling.
 */
export default function TableWrapper({ children, heightCompensation = 0 }: TableWrapperProps) {
  const { tableFooterHeight, usedHeight } = useDashboardLayout();
  const { isMobile } = useResponsiveDesign();

  const styles = useMemo(
    () => ({
      height: isMobile
        ? `calc(100vh - ${usedHeight - heightCompensation}px - env(safe-area-inset-bottom))`
        : `calc(100vh - ${usedHeight - heightCompensation}px)`,
      border: '2px solid #fff',
      borderRadius: '4px',
      display: 'grid',
      gridTemplateColumns: '100%',
      gridTemplateRows: `1fr ${tableFooterHeight}px`,
      backgroundColor: 'white',
      transition: 'opacity 30ms ease-in-out 100ms',
    }),
    [heightCompensation, isMobile, tableFooterHeight, usedHeight]
  );

  return (
    <Box data-e2e-capture-role="viewport-height-content" sx={styles}>
      {children}
    </Box>
  );
}
